import React, {useEffect} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useIntl } from 'react-intl'
import SettingList from '../setting-list'
import MeChildHeader from '../../../../components/me-child-header'
import { useSelector } from 'react-redux'

const SettingPolicy = props => {
    useStyles(classes)
    const Intl = useIntl()
    const global = useSelector(state => state.global)

    const policyList = [{
        id: 0,
        name: 'main',
        children:[
            {
                id: '0-0',
                name: Intl.formatMessage({id: 'shipping_policy'}),
                href: '/policy/shipping-policy',
                outer:true
            },
            {
                id: '0-1',
                name: Intl.formatMessage({id: 'return_policy'}),
                href: '/policy/return-policy',
                outer:true
            },
            {
                id: '0-2',
                name: Intl.formatMessage({id: 'privacy_policy_only'}),
                href: '/policy/privacy-security-policy',
                outer:true
            },
            {
                id: '0-3',
                name: Intl.formatMessage({id: 'out_of_stock_policy'}),
                href: "/policy/out-of-stock",
                outer:true
            },
            {
                id: '0-4',
                name: Intl.formatMessage({id: 'terms_conditions'}),
                href: "/policy/terms-conditions-notice",
                outer:true
            },
        ]
    }]

    const onBack = () => {
        window.history.back()
    }

    return (
        <div className={classes.SettingPolicy}>
            <MeChildHeader name={Intl.formatMessage({id: 'about_web'},{website: global?.config?.name || ''})} onBack={() => onBack()}/>

            <SettingList list={policyList}/>
        </div>
    )
}

SettingPolicy.fetchData =  async (store, params, search, headers) => {
    // await store.dispatch(action_fetch_currencies(headers))
}

export default SettingPolicy